import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import i18n from '../i18n';
import { useScanResult } from '../store/index';
import { Link, useNavigate } from 'react-router-dom';

export const ScanedList = (props) => {
    const scanResult = useScanResult((state) => state.scanResult);
    const showListDialog = useScanResult((state) => state.showListDialog);
    const removeAllScanResult = useScanResult((state) => state.removeAllScanResult);
    const setScanResultQuantity = useScanResult((state) => state.setScanResultQuantity);
    const setShowListDialog = useScanResult((state) => state.setShowListDialog);
    const removeScanResult = useScanResult((state) => state.removeScanResult);

    //const setDialogCallback = useScanResult((state) => state.setDialogCallback);
    const dialogCallback = useScanResult((state) => state.dialogCallback);

    const navigate = useNavigate();

    const footerContent = (
        <div className="flex justify-content-between w-full">
            {/* <Button label={i18n.t('artikallist.remove_all')} icon="pi pi-trash" severity="danger" outlined onClick={() => removeAllScanResult()} /> */}
            <Button
                label={i18n.t('remove_all')}
                icon="pi pi-trash"
                outlined
                severity="danger"
                onClick={() => {
                    setShowListDialog(false);
                    removeAllScanResult();
                }}
            />
            <Button label={i18n.t('close')} icon="pi pi-times" outlined onClick={() => setShowListDialog(false)} />
            {/* <Button label={i18n.t('robnidokument.preuzmi_skenirano')} severity="info" className="" icon="pi pi-plus" onClick={() => props.onAddScannedAll(scanResult)} /> */}
        </div>
    );

    const onBarcodeClick = (barcode) => {
        // Handle barcode click event
        navigate(`/mm/${barcode}/barcode`);
        setShowListDialog(false);
    };

    return (
        <div>
            <Dialog
                header="Lista skeniranih barkodova"
                visible={showListDialog}
                position="top"
                onHide={() => {
                    if (!showListDialog) return;
                    setShowListDialog(false);
                }}
                style={{ width: '50vw' }}
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                footer={footerContent}
            >
                <div className="formgrid p-fluid ">
                    {/* <pre>{JSON.stringify(scanResult, false, 2)}</pre> */}
                    {scanResult.map((item, index) => (
                        <div key={index} className="">
                            {/* <pre>{JSON.stringify(item, false, 2)}</pre> */}
                            <article
                                className="flex w-full justify-content-between align-items-center mb-3 select-none cursor-pointer surface-border hover:surface-hover border-round-lg px-2 py-1 text-800 hover:text-blue-800"
                                style={{ background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(233,233,233,1) 100%)' }}
                            >
                                <div className="flex align-items-center">
                                    {/* <Link to={`/mm/${item}/barcode`}>
                                        <span className="text-900 font-bold mr-2">{item}</span>
                                    </Link> */}
                                    <Button icon={'pi pi-search'} label={item} onClick={() => onBarcodeClick(item)} />
                                </div>
                                {!dialogCallback && (
                                    <span className="border-circle w-3rem h-3rem flex align-items-center justify-content-center surface-100">
                                        <Button icon={'pi pi-trash'} severity="danger" onClick={(e) => removeScanResult(index)} />
                                    </span>
                                )}
                                {dialogCallback && (
                                    <span className=" flex px-2 py-1 ">
                                        <InputText
                                            keyfilter="pint"
                                            // {`kolicina-${index}`}
                                            value={item.q || ''}
                                            className="mr-2"
                                            onChange={(e) => {
                                                setScanResultQuantity(index, e.target.value);
                                            }}
                                        />

                                        {/* add to document */}
                                        <Button
                                            icon={'pi pi-plus'}
                                            severity="info"
                                            onClick={(e) => {
                                                dialogCallback(item);
                                                removeScanResult(index);
                                            }}
                                        />
                                    </span>
                                )}
                            </article>
                        </div>
                    ))}
                </div>

                {/* <pre>{JSON.stringify(selectedDoc, false, 2)}</pre>
                 */}
            </Dialog>
        </div>
    );
};
